import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

const routes = [
    {
        path: "/",
        name: "login",
        component: () => import("../views/login.vue"),
    },
    {
        path: "/productSharing",
        name: "productSharing",
        component: () => import("../views/plan/ProductSharing.vue"),
    },
    {
        path: "/newNavBar",
        name: "newNavBar",
        redirect: "/newNavBar/loginIndex",
        component: () => import("../views/newNavBar.vue"),
        children: [
            {
                path: "inquiry/productInquiry",
                name: "productInquiry",
                component: () => import("../views/inquiry/productInquiry.vue"),
            },
            {
                path: "inquiry/planInquiry",
                name: "planInquiry",
                component: () => import("../views/inquiry/planInquiry.vue"),
            },
            {
                path: "inquiry/commonInquiry",
                name: "commonInquiry",
                component: () => import("../views/inquiry/commonInquiry.vue"),
            },
            {
                path: "plan",
                name: "plan",
                component: () => import("../views/plan/plan.vue"),
            },
            {
                path: "mapPlan",
                name: "mapPlan",
                component: () => import("../views/plan/mapPlan.vue"),
            },
            {
                path: "loginIndex",
                name: "loginIndex",
                component: () => import("../views/loginIndex.vue"),
            },
            {
                path: "/panel",
                name: "panel",
                meta: {
                    titile: "机构面板",
                },
                component: () => import("@/views/mechanism/panel.vue"),
                children: [
                    {
                        path: "/organization",
                        name: "organization",
                        component: () => import("@/views/mechanism/organization.vue"),
                    },
                    {
                        path: "/institutionalTeam",
                        name: "institutionalTeam",
                        component: () => import("@/views/mechanism/institutionalTeam.vue"),
                    },
                    {
                        path: "/institutionalWallet",
                        name: "institutionalWallet",
                        component: () => import("@/views/mechanism/institutionalWallet.vue"),
                    },
                    {
                        path: "/myBoard",
                        name: "myBoard",
                        component: () => import("@/views/mechanism/myBoard.vue"),
                    },
                    {
                        path: "/myDeal",
                        name: "myDeal",
                        component: () => import("@/views/mechanism/myDeal.vue"),
                    },
                    {
                        path: "/clientAnddistribution",
                        name: "clientAnddistribution",
                        component: () => import("@/views/mechanism/clientAnddistribution.vue"),
                    },
                    {
                        path: "/voiceOfTheCustomer",
                        name: "voiceOfTheCustomer",
                        component: () => import("@/views/mechanism/voiceOfTheCustomer.vue"),
                    },
                    {
                        path: "/statistics",
                        name: "statistics",
                        component: () => import("@/views/mechanism/statistics.vue"),
                    },
                ],
            },
        ],
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default router;
